import { apiClient } from './apiClient';
import type {
  BooksellerFilterState,
  BooksellerManageDto,
  CreateBooksellerDto,
  ManageBooksellersListResult,
  UpdateBooksellerDto,
} from '../types/manageBooksellers';

const BASE = '/api/app/booksellers';

function toQuery(f: BooksellerFilterState): Record<string, string | number | boolean> {
  const q: Record<string, string | number | boolean> = {
    SkipCount: (f.page - 1) * f.pageSize,
    MaxResultCount: f.pageSize,
    Sorting: `${f.sort ?? 'priority'} ${f.dir ?? 'asc'}`,
  };
  if (f.q) q.FilterText = f.q;
  if (f.isActive !== undefined) q.IsActive = f.isActive;
  if (f.authType !== undefined) q.AuthType = f.authType;
  if (f.ttsServiceLevel !== undefined) q.TtsServiceLevel = f.ttsServiceLevel;
  return q;
}

export const booksellersManageService = {
  list: async (filters: BooksellerFilterState): Promise<ManageBooksellersListResult> => {
    const { data } = await apiClient.get<{ items: BooksellerManageDto[]; totalCount: number }>(BASE, {
      params: toQuery(filters),
    });
    return data;
  },

  get: async (id: string): Promise<BooksellerManageDto> => {
    const { data } = await apiClient.get<BooksellerManageDto>(`${BASE}/${id}`);
    return data;
  },

  create: async (input: CreateBooksellerDto): Promise<BooksellerManageDto> => {
    const { data } = await apiClient.post<BooksellerManageDto>(BASE, input);
    return data;
  },

  update: async (id: string, input: UpdateBooksellerDto): Promise<BooksellerManageDto> => {
    const { data } = await apiClient.put<BooksellerManageDto>(`${BASE}/${id}`, input);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
